import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { ValidarDatosFactura } from "../../Credito/FacturarEquipo/ValidaDatosFactura";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { InputAdornment, TextField } from "@mui/material";
import { ValTextAndNumber } from "../../../Validators/ValTextAndNumber";
import { TextFieldCliente } from "../../Credito/FacturarEquipo/TextFieldCliente";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { GetDocumentpo } from "../../../Helpers/GetDocumento";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import AddCircleIcon from "@mui/icons-material/AddCircle";


const MhusaFacturarEquipo = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
  // Inyectado por ModalSolicitudCredito (ver ModalSCScreens). Habilita
  // "Siguiente" tras registrar una unidad, sin cerrar el modal.
  habilitarSiguiente,
}) => {
  const [datos_pedido, setDatos_pedido] = useState({});
  const [mostrar_registro, setMostrar_Regisrtro] = useState(false);
  const [financiamiento, setFinanciamiento] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [datos_facturacion, setDatosFacturacion] = useState({
    comentarios: "",
    comentarioscredito: "",
    estado: "",
    tiempoestimado: "",
    tiempotranscurrido: "",
    factura: false,
    nota_abono: false,
    idequip: "",
    idsucursal: "",
    serie_fiscal: "",
    folio_fiscal: "",
    documento: "",
  });
  const [sucursales_cliente, setSucursales_cliente] = useState([]);
  const [selected, setselected] = useState(null);
  const [factura, setFactura] = useState({
    documento: "",
    extension: "",
  });
  const [estatus, setEstatus] = useState({});



  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerFactura?folio=${folio}&registro=${selected.registro
        }&iddocumento=${Number(iddocumento)}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  const onImprimirPedido = () => {
    setLoader({ ...loader, mostrar: true });
    const iddocumento = 25;
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumentoPedido?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.documento;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
      });
  };
  const onGuardar = () => {
    var data = datos_facturacion;
    const validate = ValidarDatosFactura(
      data,
      factura,
      null,
      folio,
      datos_pedido.financiera,
      datos_facturacion.factura,
      datos_facturacion.nota_abono,
      selected.registro
    );

    const documento = datos_facturacion.documento;

    var mensaje = "";
    var valido = true;
    var documentosfinanciamiento = [];
    if (valido === false) {
      Swal.fire("FACTURACION", mensaje, "error");
      return;
    }
    if (validate.isValid === false) {
      Swal.fire("FACTURACION", validate.mensaje, "error");
      return;
    }
    validate.post.documentos = documentosfinanciamiento;
    validate.post.registro = selected.registro;
    setLoader({ ...loader, mostrar: true });
    request
      .post("ACJDF_Cargar_Factura/GuardarMhusa", validate.post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        setDatosFacturacion([]);
        setMostrar_Regisrtro(false);
        // commentNotification(result.mdlSolicitud);

        // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
        if (habilitarSiguiente !== undefined && habilitarSiguiente !== null)
          habilitarSiguiente();

        await Swal.fire(
          "FACTURACION",
          "Factura Registrada con exito",
          "success"
        );
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  //Informacion del pedido
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FacturarEquipo/informacion_pedido?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDatos_pedido(result.datos_pedido);
        setFinanciamiento(result.financiamiento);
        setUnidades(result.unidades);
        setEstatus(result.informacion);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  }, []);

  const onParticionar = (registro) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `FacturarEquipo/Particionar?folio=${folio}&registro=${Number(registro)}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDatos_pedido(result.datos_pedido);
        setFinanciamiento(result.financiamiento);
        setUnidades(result.unidades);
        setEstatus(result.informacion);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };
  //Informacion de cada unidad
  const onBuscarFactura = (item) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `FacturarEquipo/informacion_pedido_unidad?folio=${folio}&registro=${Number(
          item.registro
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDatosFacturacion(result.datos_pedido);
        setSucursales_cliente(result.sucursales);
        if (
          result.datos_pedido.serie_fiscal === undefined ||
          result.datos_pedido.serie_fiscal === null ||
          result.datos_pedido.serie_fiscal === ""
        )
          setMostrar_Regisrtro(true);

        setselected(item);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };

  const onDatosFacturacion = (prop, value, sbool, smensaje) => {
    setDatosFacturacion({
      ...datos_facturacion,
      [prop]: value,
    });
  };

  return (
    <div className="Facturar-equipo-timeline">
      <div className="solicitud-credito-a-facturar">
        <div className="solicitud-credito-datos-pedido scroll-4">
          <TextField
            label="Razon social"
            value={datos_pedido.razonsocial}
            size="small"
            color="success"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="RFC"
            value={datos_pedido.rfc}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Método de pago"
            value={datos_pedido.metodopago}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Forma de pago"
            value={datos_pedido.formapago}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Uso de CFDI"
            value={datos_pedido.usocfdi}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Tipo de relación"
            value={datos_pedido.tiporel}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Anticipos"
            value={datos_pedido.anticipos}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Folios de anticipos"
            value={datos_pedido.foliosanticipos}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="solicitud-credito-info-facturar scroll-4">
          <div className="solicitud-credito-info-facturar-titulo-container">
            <div className="header">Datos de factura</div>
            <div
              className={
                "solicitud-credito-info-facturar-titulo-container-boton-descargar"
              }
              onClick={() => onImprimirPedido()}
            >
              <CloudDownloadIcon />
              <div>Descargar Pedido</div>
            </div>
          </div>
          {/* Tabla para representar los equipos solicitados*/}
          <div className="container-table-unidades">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Cantidads</th>
                  <th>Linea</th>
                  <th>Modelo</th>
                  {/* <th>Importe</th> */}
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {unidades.map((item) => (
                  <tr>
                    <td>{item.cantidad}</td>
                    <td>{item.linea}</td>
                    <td>{item.modelo}</td>
                    {/* <td>{FormatMoney(item.importe)}</td> */}
                    <td className="table-unidades-agregar-unidad">
                      {item.cantidad > 1 && (
                        <AddCircleIcon onClick={() => onParticionar(item.registro)} />
                      )}
                    </td>
                    <td>
                      <ReceiptLongIcon onClick={() => onBuscarFactura(item)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Tabla de los detalles del financiamiento*/}
          <div className="container-table-financiamiento">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Vencimiento</th>
                  <th>Importe</th>
                  <th>Interes</th>
                  <th>Total Pagar</th>
                </tr>
              </thead>
              <tbody>
                {financiamiento.map((item) => (
                  <tr>
                    <td>{item.vencimiento}</td>
                    <td>{FormatMoney(item.importefinanciar)}</td>
                    <td>{FormatMoney(item.interes)}</td>
                    <td>{FormatMoney(item.totalpagar)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/*FACTURAS */}
          {selected !== undefined && selected !== null && (
            <div className="solicitud-credito-factura">
              <div className="solicitud-credito-factura-header">
                {`${selected.modelo} (${FormatMoney(selected.importe)})`}
              </div>
              <TextField
                fullWidth
                size="small"
                label="SERIE FISCAL"
                className="col1"
                type="text"
                onChange={({ target }) => {
                  ValTextAndNumber(
                    "serie_fiscal",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.serie_fiscal}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                size="small"
                label="FOLIO FISCAL"
                className="col2"
                type="text"
                onChange={({ target }) => {
                  ValTextAndNumber(
                    "folio_fiscal",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.folio_fiscal}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                size="small"
                label="DOCUMENTO EQUIP"
                className="cel3"
                type="text"
                onChange={({ target }) => {
                  ValOnlyNumber(
                    "documento",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.documento}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextFieldCliente
                array={sucursales_cliente}
                onDatosFacturacion={onDatosFacturacion}
                idequip={datos_facturacion.idequip}
              />
              <TextField
                fullWidth
                size="small"
                label="SUCURSAL"
                className="col5"
                type="text"
                value={datos_facturacion.sucursal}
                disabled={true}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BusinessIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <div className="col8">
                <div className="label-facturacion">CARGAR FACTURA</div>
                <TextField
                  // label="Cargar Factura"
                  fullWidth
                  size="small"
                  type="file"
                  onChange={({ target }) => GetDocumentpo(target, setFactura)}
                />
                {datos_facturacion.factura === true && (
                  <CheckCircleIcon
                    className="has_document"
                    onClick={() =>
                      onImprimirArchivo(
                        datos_pedido.financiera === "JDF" ? 71 : 28
                      )
                    }
                  />
                )}
              </div>
            </div>
          )}
          {mostrar_registro === true && (
            <div className="solicitud-credito-footer">
              <div
                className="solicitud-credito-footer-guardar"
                onClick={() => {
                  onGuardar();
                }}
              >
                <CheckCircleIcon />
                <div>REGISTRAR</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MhusaFacturarEquipo;